export var BUNDLE_KEY = 'UserStyle';